import React, { Component } from 'react'

export default class Actions extends Component {
    render() {
        return <div className="actions">{this.props.children}</div>
    }
}
